import log from '../utils/log'

export class BikehubPayment {
  constructor () {
    this.formSelector = '#new_purchase'
    this.squareLoadAttemps = 0
  }

  selectedPlan () {
    const $activeRow = $('.select-plan-group input:checked').first()
    if ($activeRow) {
      const $selected = $activeRow.parents('tr')
      if ($selected) {
        return {
          amountCents: parseInt($selected.attr('data-cents'), 10),
          amountDisplay: $selected.attr('data-amount')
        }
      }
    }
    // Return something if there isn't an active plan, it's probably not initialized yet
    return {}
  }

  selectedPlanFree () {
    const currentPlan = this.selectedPlan()
    if (currentPlan && currentPlan.amountCents < 1) {
      return true
    }
    return false
  }

  updateKioskRoomPurchaseAmount () {
    // Only set amounts if there is a selected plan, or else break
    // There should always be a selected plan though
    const currentPlan = this.selectedPlan()
    if (currentPlan) {
      $('.amount-due-row input').val(currentPlan.amountDisplay)
      $('.amount-due-display').text(currentPlan.amountDisplay)

      // Set the hidden field for amount_cents. Used in admin, not user
      $('#amount_cents').val(currentPlan.amountCents)
      // Change the button text if free
      const free = currentPlan.amountCents < 1
      $('#purchaseBtnWrap .btn').val(
        free ? 'Purchase with discount' : 'Purchase'
      )
      $('.card-payment').collapse(free ? 'hide' : 'show')
      if (free) {
        $(`#paymentErrors`).slideUp('fast')
      } else {
        $(`#paymentErrors`).slideDown('fast')
      }
    }
  }

  renderPaymentErrors (errorMessages) {
    log.debug(errorMessages)
    const errorMessageListItems = errorMessages
      .map(message => `<li>${message}</li>`)
      .join('')
    $(`${this.formSelector} #paymentErrors`).html(
      `<div class="alert alert-danger">
        <button aria-label="Close" class="close" data-dismiss="alert" type="button"><span aria-hidden="true">×</span></button>
        <h4>Please fix these issues:</h4>
        <ul>${errorMessageListItems}</ul>
      </div>`
    )
    $(`${this.formSelector} #paymentErrors`).slideDown()
  }

  newSquarePaymentForm () {
    const self = this
    return new SqPaymentForm({
      // Initialize the payment form elements

      applicationId: window.squareApplicationId,
      inputClass: 'sq-input',
      autoBuild: false,
      // Customize the CSS for SqPaymentForm iframe elements
      inputStyles: [
        {
          fontSize: '16px',
          lineHeight: '24px',
          placeholderColor: '#a0a0a0',
          backgroundColor: 'transparent'
        }
      ],
      // Initialize the credit card placeholders
      cardNumber: {
        elementId: 'sq-card-number',
        placeholder: 'Card Number'
      },
      cvv: {
        elementId: 'sq-cvv',
        placeholder: 'CVV'
      },
      expirationDate: {
        elementId: 'sq-expiration-date',
        placeholder: 'MM/YY'
      },
      postalCode: {
        elementId: 'sq-postal-code',
        placeholder: 'Zip code'
      },
      callbacks: {
        /*
         * callback function: cardNonceResponseReceived
         * Triggered when: SqPaymentForm completes a card nonce request
         */
        cardNonceResponseReceived: function (errors, nonce, cardData) {
          if (errors) {
            const errorMessages = errors.map(e => e.message)
            self.renderPaymentErrors(errorMessages)
            log.debug(errors)
            return
          }
          log.debug(nonce)
          $(`${self.formSelector} .squareNonceField`).val(nonce)
          $(self.formSelector).submit()
        }
      }
    })
  }

  cashPayment () {
    // Only place we do cash payments is in admin
    return window.inAdmin
  }

  initializeSquare () {
    // if there isn't a squareApplicationId, don't try to initialize square
    if (!window.squareApplicationId) {
      log.debug(`squareApplicationId blank, not initializing square`)
      return false
    }
    // if square payments isn't loaded, try again soon
    if (
      typeof SqPaymentForm === 'undefined' ||
      typeof this.newSquarePaymentForm !== 'function'
    ) {
      window.bikehubPayment.squareLoadAttemps += 1
      // Only reload the page if we've failed to find square 5 times - and if we haven't yet reloaded the page
      if (
        window.bikehubPayment.squareLoadAttemps > 5 &&
        window.location.hash != '#alreadyReloaded'
      ) {
        // This is probably a loss, just reload the page - but put already reloaded into the hash so we don't endless reload
        // ... use replaceState so we don't break the back button
        window.history.replaceState(
          {},
          window.location,
          `${window.location.pathname}#alreadyReloaded`
        )
        // window.location.hash = "#alreadyReloaded";
        return window.location.reload()
      }
      // If we've already tried to initialize a bunch, something is broken, so stop looping
      if (window.bikehubPayment.squareLoadAttemps > 20) {
        log.debug(`Failed to initialize square 20 times, quitting.`)
        return false
      }
      log.debug(
        `Square not present, trying again soon - attempt ${window.bikehubPayment.squareLoadAttemps}`
      )
      return setTimeout(window.bikehubPayment.initializeSquare, 300)
    } else if (window.squareInitialized) {
      // If things are already intitialized, bail rather than re-initializing
      return true
    }

    window.squareInitialized = true
    log.debug('initialized square')

    window.squarePaymentForm = this.newSquarePaymentForm()
    squarePaymentForm.build()

    const self = this
    $(this.formSelector).on('submit', e => {
      $(`${self.formSelector} #paymentErrors`).slideUp('fast')
      // If the nonce has been set, submit the form!
      if ($(`${self.formSelector} .squareNonceField`).val().length !== 0) {
        log.debug('nonce value present!')
        return true
      }
      if (self.selectedPlanFree()) {
        log.debug('free with discount, submitting!')
        return true
      }
      // If we haven't submitted already, run the square stuff
      squarePaymentForm.requestCardNonce()
      return false // Because we don't want to execute the form submission
    })
  }

  init () {
    this.updateKioskRoomPurchaseAmount() // set initial values
    $('.select-plan-group input').on('change', e => {
      this.updateKioskRoomPurchaseAmount()
    })

    // We're only doing cash payments on admin, so no need to square
    if (this.cashPayment()) {
      log.debug('This is a cash payment')
      return true
    }

    if (window.paymentType == 'square') {
      window.squareInitialized = false
      this.initializeSquare()
    }
  }
}
